import httpClient from "@/api/httpClient";
import AuthResponse from "@/model/AuthResponse";
import SigninRequest from "@/model/SigninRequest";
import SignupRequest from "@/model/SignupRequest";

function signin(request: SigninRequest): Promise<AuthResponse> {
  return httpClient.postJson<AuthResponse>("/api/auth/signin", request);
}

function signup(request: SignupRequest): Promise<AuthResponse> {
  return httpClient.postJson<AuthResponse>("/api/auth/signup", request);
}

const authApi = {
  signin,
  signup,
};

export default authApi;
